import { Box, StepConnector, styled, Typography } from '@mui/material';
import OnboardingBackground from '../../assets/icons/onboarding/OnboardingBackground.svg';
import OnboardingFlowBackground from '../../assets/icons/onboarding/OnboardingFlowBackground.svg';

export const OnboardingScrollableContainer = styled(Box)({
  width: '100vw',
  display: 'flex',
  overflow: 'hidden',
  scrollBehavior: 'smooth',
});

export const OnboardingContainer = styled(Box)(({ theme }) => ({
  width: '200vw',
  display: 'flex',
  backgroundColor: theme.palette.info.light,
}));

export const OnboardingPresentationContainer = styled(Box)<{ hidden?: boolean }>(({ hidden }) => ({
  width: '100vw',
  height: '100vh',
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  position: 'relative',
  transform: hidden ? 'translateX(-100%)' : 'translateX(0)',
  transition: 'transform 0.75s ease-in-out',
}));

export const OnboardingFlowContainer = styled(Box)<{ hidden?: boolean }>(({ hidden }) => ({
  width: '100vw',
  height: '100vh',
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'top',
  position: 'relative',
  transform: hidden ? 'translateX(0)' : 'translateX(-100%)',
  transition: 'transform 0.75s ease-in-out',
}));

export const OnboardingFlowLanguageSelector = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(2),
  right: theme.spacing(2),
}));

export const OnboardingImage = styled(Box)<{ flow?: boolean }>(({ flow }) => ({
  position: 'absolute',
  zIndex: -1,
  left: 0,
  width: '80%',
  height: '100%',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'contain',
  backgroundImage: `url(${!flow ? OnboardingBackground : OnboardingFlowBackground})`,
}));

export const OnboardingOptionsContainer = styled(Box)({
  width: '55%',
  height: '80%',
  marginBottom: 'auto',
  display: 'flex',
  gap: '40px',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-start',
});

export const OnboardingTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontWeight: 600,
  marginLeft: theme.spacing(12),
}));

export const OnboardingText = styled(Typography)(({ theme }) => ({
  color: theme.palette.secondary.contrastText,
  marginLeft: theme.spacing(12),
  width: '75%',
}));

export const OnboardingActionsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '20px',
  marginLeft: theme.spacing(12),
}));

export const OnboardingFlowScrollableContainer = styled(Box)(() => ({
  width: '75%',
  display: 'flex',
  flexDirection: 'column',
  height: '400vh',
}));

export const OnboardingFlowCardContainer = styled(Box)(({ theme }) => ({
  width: '75%',
  padding: `${theme.spacing(5)} ${theme.spacing(10)}`,
  marginTop: theme.spacing(10),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  maxHeight: '600px',
}));

export const OnboardingFlowStepperContainer = styled(Box)(({ theme }) => ({
  width: '15%',
  padding: `${theme.spacing(5)} ${theme.spacing(10)}`,
  marginTop: theme.spacing(10),
}));

export const OnboardingFlowStepConnector = styled(StepConnector)(({ theme }) => ({
  padding: 0,
  marginLeft: '8px',
  '& .MuiStepConnector-line': {
    borderColor: theme.palette.secondary.light,
    borderWidth: 4,
  },
}));
